import { render, staticRenderFns } from "./TreasuryModal.vue?vue&type=template&id=85033b18&scoped=true&"
import script from "./TreasuryModal.vue?vue&type=script&lang=js&"
export * from "./TreasuryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85033b18",
  null
  
)

export default component.exports